var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    transform: "translate(-0.396 0.054)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2_copy_42",
    "data-name": "Ellipse 2 copy 42",
    cx: 60,
    cy: 60,
    r: 60,
    transform: "translate(0.397 -0.054)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_profile_2136586_000000",
    transform: "translate(36.433 33.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M42.042,6.776a9.766,9.766,0,1,1-9.766,9.766,9.776,9.776,0,0,1,9.766-9.766m0-1.776A11.542,11.542,0,1,0,53.584,16.542,11.557,11.557,0,0,0,42.042,5Z",
    transform: "translate(-19.073 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M34.163,57.876a21.034,21.034,0,0,1,14.442,5.682,21.327,21.327,0,0,1,6.748,13.791H12.973a21.327,21.327,0,0,1,6.748-13.791,21.034,21.034,0,0,1,14.442-5.682m0-1.776A23.08,23.08,0,0,0,11.2,77.29a1.711,1.711,0,0,0,1.716,1.835h42.5a1.711,1.711,0,0,0,1.716-1.835A23.035,23.035,0,0,0,34.163,56.1Z",
    transform: "translate(-11.195 -28.247)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileThumb);
export default __webpack_public_path__ + "static/media/profile-thumb.77f66399d7364692829d2e4d22b56108.svg";
export { ForwardRef as ReactComponent };